if (!window.__ecInit) {
  window.__ecInit = true;
  document.documentElement.classList.add('ec-js');
  document.addEventListener('DOMContentLoaded', function () {
    ecRevelado();
    ecCuentaAtras();
    ecGaleria();
    ecVideos();
    ecPacks();
    ecCarrusel();
    ecResenaEnlaces();
    ecFijo();
    ecPlazos();
  });
}

function ecRevelado() {
  var els = document.querySelectorAll('.ec-reveal');
  if (!els.length) return;
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches || !('IntersectionObserver' in window)) {
    els.forEach(function (e) { e.classList.add('ec-visible'); }); return;
  }
  var obs = new IntersectionObserver(function (entries) {
    entries.forEach(function (e) { if (e.isIntersecting) { e.target.classList.add('ec-visible'); obs.unobserve(e.target); } });
  }, { threshold: 0.12, rootMargin: '0px 0px -40px 0px' });
  els.forEach(function (e) { obs.observe(e); });
}

/* Selector de packs: cambia la variante, el precio de la barra fija y el estado agotado.
   Se engancha al evento change de la casilla (se dispara una sola vez por elección);
   con click en la etiqueta el manejador se ejecutaba dos veces (etiqueta + clic sintético en la casilla). */
function ecPacks() {
  var precios = document.querySelectorAll('[data-ec-fijo-precio]');
  document.querySelectorAll('form[id^="ec-form-"]').forEach(function (form) {
    var id = form.querySelector('input[name="id"]');
    var boton = form.querySelector('[data-ec-boton]');
    var nota = form.querySelector('[data-ec-agotado]');
    var packs = form.querySelectorAll('[data-ec-pack]');
    var activo = form.querySelector('[data-ec-pack].ec-activa');
    if (activo) ecFotoPack(Array.prototype.indexOf.call(packs, activo) + 1);
    function aplicar(p) {
      if (p === activo) return;
      if (activo) activo.classList.remove('ec-activa');
      p.classList.add('ec-activa');
      activo = p;
      id.value = p.getAttribute('data-ec-id');
      var disp = p.getAttribute('data-ec-disponible') === 'true';
      if (boton) { boton.disabled = !disp; boton.textContent = disp ? (p.getAttribute('data-ec-texto-boton') || boton.getAttribute('data-ec-texto')) : boton.getAttribute('data-ec-texto-agotado'); }
      if (nota) nota.hidden = disp;
      var precio = p.getAttribute('data-ec-precio');
      for (var i = 0; i < precios.length; i++) precios[i].textContent = precio;
      ecFotoPack(Array.prototype.indexOf.call(packs, p) + 1);
    }
    packs.forEach(function (p) {
      var r = p.querySelector('input');
      if (r) r.addEventListener('change', function () { if (r.checked) aplicar(p); });
      else p.addEventListener('click', function () { aplicar(p); });
    });
  });
}

/* Galería de la ficha: flechas laterales y deslizar con el dedo. Si el pack elegido tiene foto especial,
   esa foto ocupa el primer lugar en lugar de la foto principal. */
function ecGaleriaFotos(cont) {
  var packImg = cont._packImg;
  var base = cont._pack && packImg ? packImg : cont.querySelector('img:not([data-ec-foto-pack-img]):not([data-ec-galeria-img])');
  var extra = [].slice.call(cont.querySelectorAll('[data-ec-galeria-img]'));
  return (base ? [base] : []).concat(extra);
}
function ecGaleriaMostrar(cont, i) {
  var fotos = ecGaleriaFotos(cont);
  if (!fotos.length) return;
  i = ((i % fotos.length) + fotos.length) % fotos.length;
  cont._i = i;
  [].forEach.call(cont.querySelectorAll('img, video'), function (im) { im.hidden = true; if (im.pause) im.pause(); });
  fotos[i].hidden = false;
  var esVideo = fotos[i].tagName === 'VIDEO';
  cont.classList.toggle('ec-foto-video', esVideo);
  var son = cont.querySelector('[data-ec-sonido]');
  if (son) {
    son.hidden = !esVideo;
    if (esVideo) {
      if (!fotos[i].poster && fotos[i].getAttribute('data-poster')) fotos[i].poster = fotos[i].getAttribute('data-poster');
      fotos[i].muted = true;
      ecSonidoEstado(cont, fotos[i]);
      var pr = fotos[i].play();
      if (pr && pr.catch) pr.catch(function () {});
    }
  }
  var sig = fotos[(i + 1) % fotos.length];
  if (sig && cont._listo) sig.loading = 'eager';
  cont.classList.toggle('ec-foto-activa', ((!!cont._pack && i === 0) || i > 0) && fotos[i].tagName !== 'VIDEO');
  [].forEach.call(cont.querySelectorAll('[data-ec-gal-dir]'), function (b) { b.hidden = fotos.length < 2; });
}
function ecSonidoEstado(cont, v) {
  var son = cont.querySelector('[data-ec-sonido]');
  if (!son) return;
  son.setAttribute('aria-pressed', v.muted ? 'false' : 'true');
  son.querySelector('span').textContent = v.muted ? 'Activar sonido' : 'Silenciar';
  son.querySelector('.ec-son-off').hidden = !v.muted;
  son.querySelector('.ec-son-on').hidden = v.muted;
}
function ecFotoPack(n) {
  var cont = document.querySelector('[data-ec-foto-pack]');
  if (!cont) return;
  cont._packImg = cont.querySelector('[data-ec-foto-pack-img][data-ec-pack-n="' + n + '"]');
  cont._pack = !!cont._packImg;
  ecGaleriaMostrar(cont, 0);
}
function ecGaleria() {
  var cont = document.querySelector('[data-ec-foto-pack]');
  if (!cont) return;
  cont._pack = false; cont._packImg = null; cont._i = 0; cont._listo = false;
  var listo = function () { cont._listo = true; ecGaleriaMostrar(cont, cont._i); };
  if (document.readyState === 'complete') setTimeout(listo, 1500); else window.addEventListener('load', function () { setTimeout(listo, 1500); });
  [].forEach.call(cont.querySelectorAll('[data-ec-gal-dir]'), function (b) {
    b.addEventListener('click', function () { ecGaleriaMostrar(cont, cont._i + parseInt(b.getAttribute('data-ec-gal-dir'), 10)); });
  });
  var v = cont.querySelector('video');
  var son = cont.querySelector('[data-ec-sonido]');
  if (v && son) {
    son.addEventListener('click', function () { v.muted = !v.muted; if (!v.muted && v.paused) v.play(); ecSonidoEstado(cont, v); });
    v.addEventListener('click', function () { if (v.paused) v.play(); else v.pause(); });
  }
  var x0 = null;
  cont.addEventListener('touchstart', function (e) { x0 = e.touches[0].clientX; }, { passive: true });
  cont.addEventListener('touchend', function (e) {
    if (x0 === null) return;
    var dx = e.changedTouches[0].clientX - x0; x0 = null;
    if (Math.abs(dx) > 40) ecGaleriaMostrar(cont, cont._i + (dx < 0 ? 1 : -1));
  }, { passive: true });
  ecGaleriaMostrar(cont, 0);
}

/* Sección de vídeos: arrancan en silencio al verse y se pausan al salir; botón para activar el sonido. */
function ecVideos() {
  var tarjetas = [].slice.call(document.querySelectorAll('[data-ec-video-tarjeta]'));
  if (!tarjetas.length) return;
  function estado(t) {
    var v = t.querySelector('video');
    var b = t.querySelector('[data-ec-video-sonido]');
    b.setAttribute('aria-pressed', v.muted ? 'false' : 'true');
    b.setAttribute('aria-label', v.muted ? 'Activar sonido' : 'Silenciar');
    b.querySelector('.ec-vs-off').hidden = !v.muted;
    b.querySelector('.ec-vs-on').hidden = v.muted;
  }
  function cargar(t) {
    var v = t.querySelector('video');
    if (!v.getAttribute('src')) {
      var p = v.getAttribute('data-poster');
      if (p) v.poster = p;
      v.src = v.getAttribute('data-src');
    }
  }
  tarjetas.forEach(function (t) {
    var v = t.querySelector('video');
    t.querySelector('[data-ec-video-sonido]').addEventListener('click', function (e) {
      e.stopPropagation();
      var activar = v.muted;
      tarjetas.forEach(function (o) { o.querySelector('video').muted = true; estado(o); });
      v.muted = !activar;
      if (!v.muted && v.paused) v.play();
      estado(t);
    });
    v.addEventListener('click', function () { if (v.paused) v.play(); else v.pause(); });
  });
  if (!('IntersectionObserver' in window)) { tarjetas.forEach(cargar); return; }
  var vistas = new IntersectionObserver(function (entradas) {
    entradas.forEach(function (e) {
      var v = e.target.querySelector('video');
      if (e.isIntersecting) {
        cargar(e.target);
        var pr = v.play();
        if (pr && pr.catch) pr.catch(function () {});
      } else {
        v.pause();
      }
    });
  }, { threshold: 0.4 });
  tarjetas.forEach(function (t) { vistas.observe(t); });
}

/* Cuenta atrás hasta una fecha fija (23:59 hora de Madrid). Al llegar a cero la barra se oculta. */
function ecCuentaAtras() { document.querySelectorAll('[data-ec-cuenta]').forEach(ecUnaCuenta); }
function ecUnaCuenta(barra) {
  var p = String(barra.getAttribute('data-ec-cuenta')).trim().split(/[-\s:T]+/);
  if (p.length < 3) return;
  var hh = p.length >= 5 ? +p[3] : 23, mi = p.length >= 5 ? +p[4] : 59, se = p.length >= 5 ? 0 : 59;
  function desfase(t) {
    var f = new Intl.DateTimeFormat('en-US', { timeZone: 'Europe/Madrid', hour12: false, year: 'numeric', month: 'numeric', day: 'numeric', hour: 'numeric', minute: 'numeric', second: 'numeric' });
    var o = {};
    f.formatToParts(new Date(t)).forEach(function (x) { o[x.type] = +x.value; });
    return Date.UTC(o.year, o.month - 1, o.day, o.hour === 24 ? 0 : o.hour, o.minute, o.second) - t;
  }
  var base = Date.UTC(+p[0], +p[1] - 1, +p[2], hh, mi, se);
  var fin = base - desfase(base);
  var d = barra.querySelector('[data-ec-cuenta-d]'), h = barra.querySelector('[data-ec-cuenta-h]'), m = barra.querySelector('[data-ec-cuenta-m]'), s = barra.querySelector('[data-ec-cuenta-s]');
  function dos(n) { return (n < 10 ? '0' : '') + n; }
  var timer;
  function pintar() {
    var resto = Math.floor((fin - Date.now()) / 1000);
    if (isNaN(resto) || resto <= 0) { barra.hidden = true; if (timer) clearInterval(timer); return; }
    d.textContent = dos(Math.floor(resto / 86400));
    h.textContent = dos(Math.floor(resto % 86400 / 3600));
    m.textContent = dos(Math.floor(resto % 3600 / 60));
    s.textContent = dos(resto % 60);
    barra.hidden = false;
  }
  pintar();
  timer = setInterval(pintar, 1000);
}

/* Carrusel de reseñas: flechas */
function ecCarrusel() {
  document.querySelectorAll('[data-ec-carrusel]').forEach(function (wrap) {
    var pista = wrap.querySelector('.ec-carrusel');
    if (!pista) return;
    wrap.querySelectorAll('[data-ec-dir]').forEach(function (b) {
      b.addEventListener('click', function () {
        var card = pista.firstElementChild;
        var paso = card ? card.getBoundingClientRect().width + 24 : 300;
        pista.scrollBy({ left: paso * parseInt(b.getAttribute('data-ec-dir'), 10), behavior: 'smooth' });
      });
    });
  });
}

/* Estrellas de la ficha -> bajan a las reseñas; "Añade tu reseña" abre el formulario */
function ecResenaEnlaces() {
  var destino = document.getElementById('resenas');
  var caja = document.getElementById('ec-form-resena');
  var enlaces = document.querySelectorAll('[data-ec-ir-resenas], [data-ec-abrir-resena]');
  var suave = !(window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches);
  if (!destino) { enlaces.forEach(function (a) { if (a.hasAttribute('data-ec-abrir-resena')) a.hidden = true; else { a.removeAttribute('href'); a.style.cursor = 'default'; } }); return; }
  function abrir(si) {
    var campos = document.querySelector('[data-ec-form-campos]'), b = document.querySelector('[data-ec-toggle-resena]');
    if (!campos || !b) return;
    campos.hidden = !si; b.setAttribute('aria-expanded', si ? 'true' : 'false'); b.hidden = si;
  }
  function ir(el) { if (el) el.scrollIntoView({ behavior: suave ? 'smooth' : 'auto', block: 'center' }); }
  document.querySelectorAll('[data-ec-ir-resenas]').forEach(function (a) {
    a.addEventListener('click', function (e) { e.preventDefault(); ir(destino); });
  });
  document.querySelectorAll('[data-ec-abrir-resena]').forEach(function (a) {
    a.addEventListener('click', function (e) { e.preventDefault(); abrir(true); ir(caja || destino); });
  });
  var tog = document.querySelector('[data-ec-toggle-resena]');
  if (tog) tog.addEventListener('click', function () { abrir(true); });
  if (/[?&]contact_posted=true/.test(location.search) && caja) ir(caja);
}

/* Botón fijo en móvil: aparece cuando el bloque de compra sale de la pantalla */
function ecFijo() {
  var fijo = document.querySelector('[data-ec-fijo]');
  var compra = document.querySelector('[data-ec-compra]');
  if (!fijo || !compra || !('IntersectionObserver' in window)) { if (fijo) fijo.classList.add('ec-mostrar'); return; }
  new IntersectionObserver(function (entries) {
    entries.forEach(function (e) { fijo.classList.toggle('ec-mostrar', !e.isIntersecting); });
  }).observe(compra);
}

/* Plazos de entrega en días LABORABLES de España (sin fines de semana ni festivos nacionales) */
var EC_FESTIVOS = ['01-01', '01-06', '05-01', '08-15', '10-12', '11-01', '12-06', '12-08', '12-25'];
var EC_VIERNES_SANTO = { 2026: '04-03', 2027: '03-26', 2028: '04-14', 2029: '03-30', 2030: '04-19' };
function ecEsLaborable(d) {
  var dia = d.getDay(); if (dia === 0 || dia === 6) return false;
  var md = ('0' + (d.getMonth() + 1)).slice(-2) + '-' + ('0' + d.getDate()).slice(-2);
  if (EC_FESTIVOS.indexOf(md) > -1) return false;
  if (EC_VIERNES_SANTO[d.getFullYear()] === md) return false;
  return true;
}
function ecSumarLaborables(n) {
  var d = new Date(); var cuenta = 0;
  while (cuenta < n) { d.setDate(d.getDate() + 1); if (ecEsLaborable(d)) cuenta++; }
  return d;
}
function ecPlazos() {
  document.querySelectorAll('[data-ec-plazos]').forEach(function (box) {
    var f = function (d) { return d.toLocaleDateString('es-ES', { day: 'numeric', month: 'short' }).replace('.', ''); };
    var prep = parseInt(box.getAttribute('data-prep'), 10) || 0;
    var min = parseInt(box.getAttribute('data-min'), 10) || 0;
    var max = parseInt(box.getAttribute('data-max'), 10) || min;
    var hoy = box.querySelector('[data-ec-fecha="hoy"]');
    if (hoy) hoy.textContent = 'Hoy, ' + f(new Date());
    var sale = box.querySelector('[data-ec-fecha="sale"]');
    if (sale) sale.textContent = f(ecSumarLaborables(prep));
    var llega = box.querySelector('[data-ec-fecha="llega"]');
    if (llega) llega.textContent = f(ecSumarLaborables(min)) + ' – ' + f(ecSumarLaborables(max));
  });
}